import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import apis from '@src/apis';
import { downloadFileUsingUrl } from '@src/utils/file';
import actions from '@src/redux/actions';
import { Typography } from '@mui/material';
import { DOWNLOAD_QUOTA_EXCEEDED_CODE } from '@src/constants/tts';
import { trackAudioDownloaded } from '@src/services/moengage';
import { MOE_MODULE, MOE_SURFACE } from '@src/constants/moengage';
import { FileDownloadOutlined } from '@mui/icons-material';
import { StyledDownloadButton } from './index.style';
import { StyledActionTooltip } from '../Requests/index.style';

const DownloadButton = ({
  hasDisable,
  onClick,
  requestId,
  title,
  getTitleActionTooltip,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleDownloadAudio = async () => {
    if (hasDisable) return;
    onClick();
    const res = await apis.requests.getPresignedAudioUrl(requestId);
    if (res?.status) {
      const audioUrl = res.result?.audio;
      trackAudioDownloaded({
        requestId,
        module: MOE_MODULE.TTS,
        surface: MOE_SURFACE.TITLE_BAR,
      });
      downloadFileUsingUrl(audioUrl);
      return;
    }
    if (res?.errorCode === DOWNLOAD_QUOTA_EXCEEDED_CODE) {
      dispatch(actions.user.updateShowBlockDownloadDialog(true));
      return;
    }

    dispatch(
      actions.noti.push({
        severity: 'error',
        message: 'downloadError',
        value: title,
      }),
    );
  };

  return (
    <StyledActionTooltip
      title={getTitleActionTooltip('')}
      arrow
      placement="bottom"
      disabled={hasDisable}
    >
      <StyledDownloadButton
        className="download-button default-background"
        onClick={handleDownloadAudio}
        role="button"
        tabIndex="0"
        disabled={hasDisable}
      >
        <FileDownloadOutlined className="download-icon" />
        <Typography className="text-download">{t('download')}</Typography>
      </StyledDownloadButton>
    </StyledActionTooltip>
  );
};

export default DownloadButton;
